import { apiRequest } from "../../lib/api-client";
import type { GatePassVariant } from "../admin/types";

// Trimmed to exactly what GET /visits/public-badge returns for the
// template -- not the full GatePassTemplate shape (no is_active/created_at,
// since those don't mean anything to an anonymous visitor's own badge page).
export type PublicBadgeTemplate = {
  id: number | null;
  name: string;
  variant: GatePassVariant;
  accent_color: string;
  footer_text?: string | null;
  is_builtin: boolean;
};

export type PublicBadge = {
  badge_code: string;
  visitor_name: string;
  company: string | null;
  host_name: string;
  purpose: string;
  status: string;
  checkin_time: string | null;
  checkout_time: string | null;
  expected_exit: string | null;
  template: PublicBadgeTemplate;
  tenant_company_code: string;
};

export function getPublicBadge(badgeCode: string) {
  return apiRequest<PublicBadge>(`/visits/public-badge/${encodeURIComponent(badgeCode)}`);
}
